module.exports = __webpack_public_path__ + "static/media/info.4ebcc685.svg";